import React, { Component } from 'react';
import {
    // SearchBox,
    IIconProps,
    PrimaryButton
} from 'office-ui-fabric-react';

import '../styles/search.css';
import SearchBox from "./searchbox";
import { EventEmitter } from './events';

interface IState {
    token: string;
    name: string;
    image: string;
    userName: string;
    userId: string;
    firstName: string;
    originalURL: string;
    searchLabel: string;
    searchText: string;
    matterURL: string;
    globalsearchURL: string;
    matterDetailURL: string;
    formActionURL: string;
    formTarget: string;
    isLoaded: boolean;
}

interface ISearch {
    parentLoading: any;
}

const filterIcon: IIconProps = { iconName: 'search' };

const queryString = ((a) => {
    if (a == "") return {};

    var b = {};
    for (var i = 0; i < a.length; ++i) {
        var p = a[i].split('=', 2);
        if (p.length == 1)
            b[p[0]] = "";
        else
            b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
    }
    return b;
})(window.location.search.substr(1).split('&'));

class Search extends Component<ISearch, IState> {

    constructor(props: ISearch) {
        super(props);
        this.state = {
            token: '',
            name: '',
            image: '',
            userName: '',
            firstName: '',
            userId: '',
            originalURL: '',
            searchLabel: 'Search',
            searchText: '',
            matterURL: '',
            globalsearchURL: '',
            matterDetailURL: '',
            formActionURL: '',
            formTarget: '',
            isLoaded: false,
        };

        EventEmitter.subscribe('onSearch', (param: any) => {
          
            this.setState({
                formTarget: '',
                searchText: param.Text,
                originalURL: this.state.globalsearchURL + '?search=' + param.Text + "&sec=" + queryString['sec'],
                formActionURL: this.state.globalsearchURL + '?search=' + param.Text + "&sec=" + queryString['sec']
            }, () => {
                this.onSearch();
            });

        });
    }


    onTextChanged = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, text: string): void => {
        const matterFormatOne = new RegExp('^[A-Za-z]{1}\\\d{4}-\\\d{5}$');
        const matterFormatTwo = new RegExp('^\\\d{5}-\\\d{5}$');

        if (matterFormatOne.test(text.trim()) || matterFormatTwo.test(text.trim())) {
            this.setState({
                searchLabel: 'Go to Matter',
                formTarget: '_blank',
                searchText: text.trim(),
                originalURL: this.state.matterURL + '/Matter?matterCode=' + text.trim() + '#/Documents',
                formActionURL: this.state.matterURL + '/Route/PostToken'
            });
        } else {
            this.setState({
                searchLabel: 'Search',
                formTarget: '',
                searchText: text,
                originalURL: this.state.globalsearchURL + '?search=' + text,
                formActionURL: this.state.globalsearchURL + '?search=' + text
            });
        }
    }

    onSearch = () => {
        let searchForm = document.getElementById('search_form');
        let userSession = JSON.parse(localStorage.getItem('userSession'));
        let encodedImageString = window.btoa(userSession.image);

        if (this.state.searchLabel === 'Search') {
            this.props.parentLoading();
        }

        this.setState({
            name: userSession.name,
            token: userSession.token,
            image: encodedImageString,
            userName: userSession.userName,
            userId: userSession.id
        }, () => searchForm.submit());

        //searchForm.submit();
    }

    getUserSession = () => {
        // Get current user name
        let userSession = JSON.parse(localStorage.getItem('userSession'));
        let fullname = userSession.name;
        let spaceIndex = fullname.indexOf(' ');
        let firstname = fullname;
        if (spaceIndex > 0) {
            firstname = fullname.substring(0, spaceIndex);
        }

        // Get API URL
        let apiURL = JSON.parse(localStorage.getItem('api'));

        this.setState({
            firstName: firstname,
            matterURL: apiURL.matterdetail,
            globalsearchURL: apiURL.globalsearch
        });
    }


    getAPI() {
        return new Promise(resolve => {
            resolve(
                localStorage.getItem("api")
            );
        });
    }

    componentDidMount() {
        this.getAPI().then(res => {
            let api = JSON.parse(res);
            this.setState({
                globalsearchURL: api.globalsearch,
                matterDetailURL: api.matterdetail,
                isLoaded: true
            }, () => {
                if (typeof window !== 'undefined') {
                    window.addEventListener('load-trigger', this.getUserSession);
                }
            });
        });

    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('load-trigger', this.getUserSession);
        }
    }

    public render() {
        const { isLoaded } = this.state;
        if (!isLoaded) return <div>Loading...</div>;
        else {
            return (
                <form className='form' id='search_form' action={this.state.formActionURL} target={this.state.formTarget} method='post'>
                    <input type='hidden' name='token' value={this.state.token}></input>
                    <input type='hidden' name='image' value={this.state.image}></input>
                    <input type='hidden' name='name' value={this.state.name}></input>
                    <input type='hidden' name='userName' value={this.state.userName}></input>
                    <input type='hidden' name='userId' value={this.state.userId}></input>
                    <input type='hidden' name='originalIUrl' value={this.state.originalURL}></input>
                    <div className="searchBox">
                        <SearchBox searchText={this.state.searchText} matterDetailsURL={this.state.matterDetailURL} />

                        {/* <SearchBox
                            onChange={this.onTextChanged}
                            iconProps={filterIcon}
                            onSearch={this.onSearch}
                            placeholder='Search'
                        />
                        <PrimaryButton type='submit' className='search-btn' onClick={this.onSearch} text={this.state.searchLabel} /> */}
                    </div>
                </form>
            );
        }
    }
}

export default Search;